import * as types from './constants';

const initialState = {
  data: {
    company_name: '',
    email: '',
    contact_person: '',
    phone_number: '',
    address_line_one: '',
    address_line_two: '',
    zip_code: '',
    city: '',
    country_code: '',
    state: '',
    logo: '',
    small_logo: '',
    cover_image: ''
  },
  getLoading: false,
  editLoading: false,
  errors_api: {}
};

const actions = {
  // Get Contact Details
  [types.GET_CONTACT_DETAILS_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_CONTACT_DETAILS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_CONTACT_DETAILS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Change Contact Details
  [types.CHANGE_CONTACT_REQUEST]: state => {
    const data = {
      ...state,
      editLoading: true
    };

    return { ...data };
  },

  [types.CHANGE_CONTACT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.CHANGE_CONTACT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Actions
  [types.CLEAR_CONTACT_ERRORS]: state => {
    const data = {
      ...state,
      errors_api: {}
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};